/** @jsx jsx */
import { jsx } from '@emotion/core'
import React, {
  useState,
  useEffect,
  useContext,
  useRef,
  useCallback,
} from 'react'
import { strCol } from '@integec/grid-tools/lib/cols'
import { toSelectionColProps } from '@integec/grid-tools/lib/utils'
import {
  getApiTargetInfo,
  getEnvConfig,
  getPermitActions,
  ExportComponent,
  EditableGrid,
} from 'core'
import {
  getUnitNameMap,
  getUtilityUnitsMap,
  getCompanyNameMap,
  getUserCompany,
  getUserInfo,
} from 'core/selectors'
import {
  modifierCol,
  modifiedDateCol,
  utilityHeader,
  unitIdHeader,
} from 'core/HeaderColTypeProps'
import { connect } from 'react-redux'
import moment from 'moment'
import {
  getOwnershipAccess,
  saveOwnershipAccess,
  deleteOwnershipAccess,
  getUtilityNameMap,
  getCompanyInfo,
} from 'api/pgads.js'
import { message, Select, Button, Input, Tabs, Popconfirm, Modal } from 'antd'
import {
  Content,
  CriteriaRow,
  Filler,
  FullHeightSizer,
  Label,
  Title,
} from 'core/screen-util'

import RM from 'ramda'
import * as ScreenPermissions from 'core/EventActions'
import {
  hasAccesPermits,
  exportDataComponent,
  rowHeaderRender,
} from 'core/utils'
import {
  freeEditEngine,
  defaultVirtualizedCellRender,
  Grid,
  virtualizedGridRenderer,
} from '@integec/grid-tools'
import { ErrorContext, SpinContext } from 'context'

const title = 'Ownership Access'
const OwnershipAccess = ({
  companyNameMap,
  unitNameMap,
  apiTargetInfo,
  envConfig,
  actionPermits,
}) => {
  const isShowCompanySelection = hasAccesPermits({
    authGodMode: envConfig.authGodMode,
    actionPermits,
    eventActions: [ScreenPermissions.OWNERSHIP_ACCESS_SHOW_COMPANY],
    matchAny: true,
  })
  const { setError } = useContext(ErrorContext)
  const { setSpinning, spinning } = useContext(SpinContext)
  const [companyList, setCompanyList] = useState([])
  const [company, setCompany] = useState(isShowCompanySelection ? [] : ['ALL'])
  //   const [effectiveDataCheck, setEffectiveDataCheck] = useState(true)
  const [activeKey, setActiveKey] = useState('data')
  const [utilityNameMap, setUtilityNameMap] = useState({})
  const [fuzzyFilter, setFuzzyFilter] = useState('')
  const [editInfo, setEditInfo] = useState(
    freeEditEngine.generateInitialEditInfo()
  )
  const [data, setData] = useState([])
  const [dataBackup, setDataBackup] = useState([])

  const [remEditInfo, setRemEditInfo] = useState(
    freeEditEngine.generateInitialEditInfo()
  )
  const [remData, setRemData] = useState([])

  useEffect(
    _ => {
      getCompanyInfo(apiTargetInfo).fork(setError, setCompanyList)
    },
    [apiTargetInfo, setError]
  )

  useEffect(
    _ => getUtilityNameMap(apiTargetInfo)().fork(_ => _, setUtilityNameMap),
    [apiTargetInfo]
  )

  const isEditable = hasAccesPermits({
    authGodMode: envConfig.authGodMode,
    actionPermits,
    eventActions: [ScreenPermissions.CHANGE_PERMISSIONS],
    matchAny: true,
  })

  const onCriteriaChnage = _ => {
    setData([])
    setDataBackup([])
    setEditInfo(freeEditEngine.generateInitialEditInfo())
    setRemData([])
    setRemEditInfo(freeEditEngine.generateInitialEditInfo())
    setActiveKey('data')
    setSelectedRow({})
  }

  const modifySaveDataBeforeSave = data =>
    data.map(d => ({
      ...d,
      effectiveFrom: moment(d.effectiveFrom, 'MM/DD/YYYY').format('YYYY-MM-DD'),
      modificationInfo: undefined,
    }))

  const modifyTask = _ => {
    if (editInfo.updated.length <= 0 && remEditInfo.updated.length <= 0) {
      message.warning('Please, modify data for save ')
      return
    }

    let saveData = freeEditEngine.applyEdits({
      data: data.filter(d => d.updated),
      editInfo,
    })

    const saveRemData = freeEditEngine.applyEdits({
      data: remData.filter(d => d.updated),
      remEditInfo,
    })

    saveData = modifySaveDataBeforeSave([...saveData, ...saveRemData])

    setSpinning(true)
    saveOwnershipAccess(apiTargetInfo)(saveData).fork(setError, _ => {
      setSpinning(false)
      message.info('Data Saved.')
      onCriteriaChnage()
      retrieve()
    })
  }
  const [selectedRow, setSelectedRow] = useState({})

  const onSelectionChange = rowData => {
    setSelectedRow(rowData)
  }
  const deleteTask = _ => {
    let da = selectedRow?.selectedRows || []
    // if someone change tto 'READ' andd before update they try to save then need to show old  vlaue
    da = da
      .map(d =>
        dataBackup.find(
          f =>
            d.companyId === f.companyId &&
            d.utility === f.utility &&
            d.unitId === f.unitId
        )
      )
      .filter(f => !!f)
    console.log(da)

    const foundALL = da.filter(f => f.accessType === 'A')
    if (foundALL.length > 0) {
      Modal.info({
        title: `Delete - Access Type - "ALL"`,
        width: 1000,
        height: 450,
        content: (
          <div>
            {/* <p>{`Required to change Access Type - "READ" before delete  the Unit.`}</p> */}
            <p>
              Below list contains the Unit Access with 'ALL', This need to be
              change to READ or 'NONE'
            </p>
            <div style={{ height: 400 }}>
              <Grid
                headers={headerWithFormatter(deleteheaders)}
                data={foundALL}
                render={virtualizedGridRenderer({
                  autoFixColByKey: false,
                  rowHeaderRender,
                  height: 400,
                  width: 850,
                  headerRowHeight: 30,
                  cellRender: defaultVirtualizedCellRender,
                })}
              />
            </div>
          </div>
        ),
      })
      return
    }
    deleteOwnershipAccess(apiTargetInfo)(
      modifySaveDataBeforeSave(selectedRow.selectedRows)
    ).fork(setError, _ => {
      message.info('Data Saved')
      retrieve()
    })
  }
  const retrieve = useCallback(
    _ => {
      if (company.length === 0) {
        message.warning('Please,Select Company')
        return
      }
      setSpinning(true)
      getOwnershipAccess(apiTargetInfo)({
        companyList: company.includes('ALL') ? [] : company,
        allData: company.includes('ALL'),
      }).fork(setError, data => {
        setSpinning(false)
        const nd = data.map(d => ({
          ...d,
          effectiveFrom: moment(d.effectiveFrom).format('MM/DD/YYYY'),
        }))
        setData(nd.filter(d => d.accessType !== 'N'))
        setDataBackup(nd.filter(d => d.accessType !== 'N'))
        setEditInfo(freeEditEngine.generateInitialEditInfo())
        setRemData(nd.filter(d => d.accessType === 'N'))
        setRemEditInfo(freeEditEngine.generateInitialEditInfo())
        setActiveKey('data')
        setSelectedRow({})
      })
    },
    [apiTargetInfo, company, setError, setSpinning]
  )
  const headerWithFormatter = useCallback(
    (hdr = headers) =>
      hdr.map(header =>
        header.ident === 'companyId'
          ? {
              ...header,
              dataFormatter: ({ value }) =>
                value + ' - ' + companyNameMap[value] || value,
              sortIndexGetter: ({ rowData }) =>
                companyNameMap[rowData.companyId] || rowData.companyId,
            }
          : header.ident === 'utility'
          ? {
              ...header,
              dataFormatter: ({ value }) =>
                value + ' - ' + utilityNameMap[value] || value,
              sortIndexGetter: ({ rowData }) =>
                utilityNameMap[rowData.utility] || rowData.utility,
            }
          : header.ident === 'unitId'
          ? {
              ...header,
              choices: [],
              dataFormatter: ({ value, rowData }) =>
                rowData.unit + ' - ' + unitNameMap[value] || value,
              sortIndexGetter: ({ rowData }) =>
                unitNameMap[rowData.unitId] || rowData.unitId,
            }
          : header
      ),
    [companyNameMap, unitNameMap, utilityNameMap]
  )
  // const companyNameSort = (a, b) =>
  //   (companyNameMap[a] || a).localeCompare(companyNameMap[b] || b)

  const isEditableTable = ({ header }) => {
    const { ident } = header
    if (!isEditable) return false
    if (
      ident === 'modifier' ||
      ident === 'modifiedDate' ||
      ident === 'companyId' ||
      ident === 'utility' ||
      ident === 'unitId'
    )
      return false
    return true
  }
  useEffect(
    _ => {
      if (!isShowCompanySelection) retrieve()
    },
    [
      apiTargetInfo,
      company,
      retrieve,
      setError,
      setSpinning,
      isShowCompanySelection,
    ]
  )
  // useEffect(retrieve, [apiTargetInfo, company, setError, setSpinning])
  const GridData = useRef()
  const GridRem = useRef()
  const exportData = _ => {
    const avaDataExport = exportDataComponent(GridData, data || [], fuzzyFilter)
    const remDataExport = exportDataComponent(
      GridRem,
      remData || [],
      fuzzyFilter
    )
    const actData = [...avaDataExport, ...remDataExport]
    new ExportComponent({
      headers: headerWithFormatter(),
      data: actData,
      fileName: title,
      getData: _ => actData,
    }).exportCSVData()
  }

  return (
    <div
      css={{
        backgroundColor: '#f0f2f5',
        marginLeft: '20px',
        marginRight: '20px',
      }}
    >
      <CriteriaRow>
        <Title
          style={{
            marginRight: '15px',
            marginBottom: '5px',
            width: '170px',
            minwidth: '170px',
          }}
        >
          {title}
        </Title>

        <Button
          icon="database"
          loading={spinning}
          onClick={retrieve}
          css={{ marginLeft: '10px' }}
          type="primary"
        >
          Retrieve
        </Button>

        {isEditable && (
          <React.Fragment>
            <Button
              loading={spinning}
              onClick={modifyTask}
              css={{ marginLeft: '10px' }}
              icon="edit"
              type="primary"
            >
              Update
            </Button>
            <Popconfirm
              title="Are you sure?"
              okText="Yes"
              cancelText="No"
              onConfirm={deleteTask}
              disabled={
                selectedRow.selectedRows && selectedRow.selectedRows.length <= 0
              }
              placement="topRight"
              // disabled
            >
              <Button
                // loading={loading}
                icon="delete"
                style={{
                  marginLeft: '10px',
                  // color: '#FFFFFF',
                  // backgroundColor: '#FF0000',
                }}
                type="danger"
                disabled={
                  !selectedRow.selectedRows ||
                  (selectedRow.selectedRows &&
                    selectedRow.selectedRows.length <= 0)
                }
              >
                Remove
              </Button>
            </Popconfirm>
          </React.Fragment>
        )}
        <Filler />
        <Input.Search
          placeholder="Filter"
          value={fuzzyFilter}
          style={{ marginLeft: '10px', marginRight: '10px', maxWidth: '200px' }}
          onChange={e => setFuzzyFilter(e.target.value)}
        />
        <Button
          Style={{ marginRight: '10px' }}
          onClick={exportData}
          icon="export"
        >
          Export
        </Button>
      </CriteriaRow>
      {isShowCompanySelection && (
        <CriteriaRow style={{ paddingTop: 5, paddingBottom: '5' }}>
          <Label css={{ minWidth: '150px' }}>Company :</Label>
          <Select
            value={company}
            onChange={com => {
              if (com.length > 15) {
                message.warn('maximum allowed company selection is 15')
                return
              }
              setCompany(com)
              onCriteriaChnage()
            }}
            mode="multiple"
            showSearch
            optionFilterProp="children"
            filterOption={(input, option) =>
              option.props.children
                .toLowerCase()
                .indexOf(input.toLowerCase()) >= 0
            }
            style={{ width: '100%', marginLeft: 5 }}
          >
            {companyList.length <= 5 && (
              <Select.Option key="ALL" value="ALL">
                All
              </Select.Option>
            )}
            {RM.sortBy(RM.compose(RM.toLower, RM.prop('companyName')))(
              companyList
            ).map(({ companyName, companyId }) => (
              <Select.Option key={companyId} value={companyId}>
                {companyName}
              </Select.Option>
            ))}
          </Select>
        </CriteriaRow>
      )}
      <FullHeightSizer heightOffset={210 + (isShowCompanySelection ? 50 : 0)}>
        {({ height, width }) => (
          <Content css={{ height: height - 20, paddingTop: '10px' }}>
            <Tabs activeKey={activeKey} onChange={setActiveKey} type="card">
              <Tabs.TabPane title="Data" key="data" tab="Data">
                <div style={{ height: height, width: width }}>
                  <EditableGrid
                    cref={GridData}
                    isEditable={isEditableTable}
                    headerRowHeight={30}
                    height={height - 100}
                    width={width - 50}
                    header={headerWithFormatter()}
                    setEditInfo={setEditInfo}
                    data={data}
                    editInfo={editInfo}
                    setData={setData}
                    fuzzyFilter={fuzzyFilter}
                    sortEnabled
                    cellRender={defaultVirtualizedCellRender}
                    onSelectionChange={onSelectionChange}
                    selectionMode="multi"
                    altBy={d =>
                      companyNameMap[d.companyId] +
                      '||' +
                      utilityNameMap[d.utility]
                    }
                    initialSortOptions={[
                      strCol({
                        ident: 'companyId',
                        sortOrder: 'asc',
                        display: 'Company',
                      }),
                      strCol({
                        ident: 'utility',
                        sortOrder: 'asc',
                        display: 'Utility',
                      }),
                      strCol({
                        ident: 'unitId',
                        sortOrder: 'asc',
                        display: 'Unit',
                      }),
                    ]}
                    // sortOptions={[
                    //   strCol({
                    //     ident: 'companyId',
                    //     sortOrder: 'asc',
                    //     display: 'Company',
                    //   }),
                    //   strCol({
                    //     ident: 'utility',
                    //     sortOrder: 'asc',
                    //     display: 'Utility',
                    //   }),
                    //   strCol({
                    //     ident: 'unitId',
                    //     sortOrder: 'asc',
                    //     display: 'Unit',
                    //   }),
                    // ]}
                  />
                </div>
              </Tabs.TabPane>
              <Tabs.TabPane title="rem" key="rem" tab="Remaining">
                <div style={{ height: height, width: width }}>
                  <EditableGrid
                    cref={GridRem}
                    isEditable={isEditableTable}
                    headerRowHeight={30}
                    height={height - 100}
                    width={width - 50}
                    header={headerWithFormatter()}
                    setEditInfo={setRemEditInfo}
                    data={remData}
                    editInfo={remEditInfo}
                    setData={setRemData}
                    fuzzyFilter={fuzzyFilter}
                    sortEnabled
                    cellRender={props => defaultVirtualizedCellRender(props)}
                    altBy={d =>
                      companyNameMap[d.companyId] +
                      '||' +
                      utilityNameMap[d.utility]
                    }
                    initialSortOptions={[
                      strCol({
                        ident: 'companyId',
                        sortOrder: 'asc',
                        display: 'Company',
                      }),
                      strCol({
                        ident: 'utility',
                        sortOrder: 'asc',
                        display: 'Utility',
                      }),
                      strCol({
                        ident: 'unitId',
                        sortOrder: 'asc',
                        display: 'Unit',
                      }),
                    ]}
                    sortOptions={[
                      strCol({
                        ident: 'companyId',
                        sortOrder: 'asc',
                        display: 'Company',
                      }),
                      strCol({
                        ident: 'utility',
                        sortOrder: 'asc',
                        display: 'Utility',
                      }),
                      strCol({
                        ident: 'unitId',
                        sortOrder: 'asc',
                        display: 'Unit',
                      }),
                    ]}
                  />
                </div>
              </Tabs.TabPane>
            </Tabs>
          </Content>
        )}
      </FullHeightSizer>
    </div>
  )

  // return (
  //   <CommonScreen
  //     title={title}
  //     header={headerWithFormatter}
  //     saveTask={modifyTask}
  //     retrieveTask={retrieveTask}
  //     withCriteria={() => (company.includes('ALL') ? userCompany : company)}
  //     withUnitSelection={false}
  //     deleteTask={deleteTask}
  //     autoRetrieve={false}
  //     altBy={d => d.companyId}
  //     sortOptions={[
  //       { ident: 'companyId', display: 'Company', sortOrder: 'asc' },
  //       utilityHeader,
  //       unitIdHeader,
  //     ]}
  //     insertComp={false}
  //     insertCompHeight={1}
  //     onInsertEvent={() => false}
  //     headerRowHeight={30}
  //     withoutModify={false}
  //     allowInsert={false}
  //     extraCriteria={extraCriteria}
  //     noDataText="Please, Select Company(s) and Retrieve Data"
  //     modifySaveDataBeforeSave={modifySaveDataBeforeSave}
  //     autoFixColByKey={false}
  //     beforeRetrieveValidation={() => {
  //       if (company.length <= 0) {
  //         message.error('Please,Select Company')
  //         return false
  //       }
  //       return true
  //     }}
  //   />
  // )
}

const headers = [
  strCol({
    ident: 'companyId',
    display: 'Company',
    width: 350,
    isKey: true,
  }),
  utilityHeader,
  unitIdHeader,
  strCol({
    ident: 'accessType',
    display: 'Access Type',

    ...toSelectionColProps({ R: 'READ', A: 'ALL', N: 'NONE' }),
    isEditable: true,
  }),
  strCol({
    ident: 'effectiveFrom',
    display: 'Effective From',
    isEditable: true,
  }),
  modifierCol,
  modifiedDateCol,
]

const mapStateToProps = state => ({
  apiTargetInfo: getApiTargetInfo(state),
  companyNameMap: getCompanyNameMap(state),
  // utilityNameMap: getUtilityNameMap(state),
  unitNameMap: getUnitNameMap(state),
  utilityUnitMap: getUtilityUnitsMap(state),
  userCompany: getUserCompany(state),
  envConfig: getEnvConfig(state),
  actionPermits: getPermitActions(state),
  userInfo: getUserInfo(state),
})

export default connect(mapStateToProps)(OwnershipAccess)

const deleteheaders = [
  // strCol({
  //   ident: 'companyId',
  //   display: 'Company',
  //   width: 350,
  //   isKey: true,
  // }),
  utilityHeader,
  unitIdHeader,
  strCol({
    ident: 'accessType',
    display: 'Access Type',
    ...toSelectionColProps({ R: 'READ', A: 'ALL', N: 'NONE' }),
    isEditable: true,
  }),
]
